import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Tag } from "lucide-react";
import { api, mediaUrl } from "../lib/api";

export default function Places() {
  const [places, setPlaces] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [city, setCity] = useState("");

  useEffect(() => { api.markets().then(setMarkets).catch(() => {}); }, []);
  useEffect(() => { api.places(city ? { city } : {}).then(setPlaces).catch(() => {}); }, [city]);

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-xs font-bold uppercase tracking-wider text-brand-gold">Explora tu comunidad</span>
        <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Lugares para visitar</h1>
        <p className="mt-2 text-muted-foreground">Mercados, cultura, eventos y destinos relevantes para la comunidad latina.</p>
      </div>

      <div className="ml-scroll mt-5 flex gap-2 overflow-x-auto pb-1">
        <Chip active={!city} onClick={() => setCity("")}>Todas las ciudades</Chip>
        {markets.map((m) => <Chip key={m.slug} active={city === m.city} testid={`place-city-${m.slug}`} onClick={() => setCity(city === m.city ? "" : m.city)}>{m.label}</Chip>)}
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {places.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            data-testid={`place-card-${p.id}`}
            className="group overflow-hidden rounded-2xl border border-border bg-card transition-all hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="relative h-44 overflow-hidden bg-muted">
              {p.image_url && <img src={mediaUrl(p.image_url)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
              <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-0.5 text-xs font-bold capitalize text-brand-ink backdrop-blur">{p.type}</span>
            </div>
            <div className="p-4">
              <h3 className="font-display text-lg font-bold text-brand-ink">{p.name}</h3>
              <div className="mt-1 flex items-center gap-1 text-xs font-medium text-muted-foreground">
                <MapPin className="h-3.5 w-3.5" /> {p.city}, {p.state}
              </div>
              <p className="mt-2 line-clamp-3 text-sm text-muted-foreground">{p.description}</p>
              {p.tags?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {p.tags.map((t) => (
                    <span key={t} className="inline-flex items-center gap-1 rounded-full bg-secondary px-2 py-0.5 text-[11px] font-medium text-brand-ink">
                      <Tag className="h-3 w-3" /> {t}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

const Chip = ({ children, active, onClick, testid }) => (
  <button data-testid={testid} onClick={onClick} className={`shrink-0 whitespace-nowrap rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors ${active ? "border-brand bg-brand text-white" : "border-border bg-white text-brand-ink hover:border-brand/40"}`}>
    {children}
  </button>
);
